<template>
  <StaffLayout section="Alert History Detail" showHeader>
    <Loading v-if="isLoading" />
    <div v-else>
      <div class="mt-4" v-if="historyDetail">
        <div>
          <div>Date Sent: {{ formatDateTime(historyDetail.dateSent) }}</div>
          <div>Sender id: {{ historyDetail.senderPersonId }}</div>
          <div class="font-bold mt-3">Message Text:</div>
          <div class="font-serif pl-4 pb-4 italic">{{ historyDetail.messageText }}</div>

          <div class="font-bold">Message Log:</div>
          <div class="font-mono text-xs pl-4 pb-4 italic">
            {{ historyDetail.messageLog }}
          </div>
          <div class="font-bold">Sending Errors:</div>
          <div class="font-mono pl-4">{{ historyDetail.messageError ?? "None" }}</div>
        </div>
      </div>

      <!--  Email Recipients -->
      <div class="mt-8" v-if="emailHistoryDetail?.length > 0">
        <div class="font-bold pb-3">Email Recipients:</div>
        <table>
          <thead>
            <tr>
              <th>Email Address</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="emailDetail in emailHistoryDetail" class="font-mono text-xs">
              <td>{{ emailDetail.emailAddress }}</td>
              <td :title="emailDetail.fullDetails">
                {{ emailDetail.fullDetails?.substring(0, 100) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>No email recipient details found</div>

      <!--  SMS Recipients -->
      <div class="mt-8" v-if="smsHistoryDetail?.length > 0">
        <div class="font-bold pb-3">SMS Recipients:</div>
        <table>
          <thead>
            <tr>
              <th>SMS Address</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="smsDetail in smsHistoryDetail" class="font-mono text-xs">
              <td>{{ smsDetail.smsNumber }}</td>
              <td>{{ smsDetail.callbackDetails }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>No SMS recipient details found</div>

      <!--  Push Notification Recipients -->
      <div class="mt-8" v-if="pushHistoryDetail?.length > 0">
        <div class="font-bold pb-3">Push Notification Recipients:</div>
        <table>
          <thead>
            <tr>
              <th>Push Token</th>
              <th>Status</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="pushDetail in pushHistoryDetail" class="font-mono text-xs">
              <td :title="pushDetail.pushToken">
                {{ pushDetail.pushToken?.substring(0, 20) }}...
              </td>
              <td>
                <span v-if="pushDetail.callbackSuccess === true" class="text-green-600">Success</span>
                <span v-else-if="pushDetail.callbackSuccess === false" class="text-red-600">Failed</span>
                <span v-else class="text-gray-400">Pending</span>
              </td>
              <td :title="pushDetail.callbackDetails">
                {{ pushDetail.callbackDetails?.substring(0, 100) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>No push notification recipient details found</div>
    </div>
  </StaffLayout>
</template>

<script setup lang="ts">
import { useAlertStore } from "../../store/alertStore";
import {
  AlertHistoryDTO2,
  AlertHistoryDetailsDTO,
} from "../../store/generatedFetchClient";
import { formatDateTime } from "../../helpers";

const alertStore = useAlertStore();
const route = useRoute();
var isLoading = ref(false);

var historyDetail = computed<AlertHistoryDTO2>(() => alertStore.historyDetail);

var emailHistoryDetail = computed<AlertHistoryDetailsDTO[]>(() =>
  alertStore.historyDetail.details.filter((x) => x.emailAddress?.length > 1)
);

var smsHistoryDetail = computed<AlertHistoryDetailsDTO[]>(() =>
  alertStore.historyDetail.details.filter((x) => x.smsNumber?.length > 1)
);

var pushHistoryDetail = computed<AlertHistoryDetailsDTO[]>(() =>
  alertStore.historyDetail.details.filter((x) => x.pushToken?.length > 1)
);

onMounted(loadData);

async function loadData() {
  if (route.params.alertHistoryId && typeof route.params.alertHistoryId === "string") {
    let alertHistoryId = Number.parseInt(route.params.alertHistoryId);

    isLoading.value = true;
    await alertStore.getHistoryDetails(alertHistoryId);
    isLoading.value = false;
  }
}
</script>
